// extracted by mini-css-extract-plugin
export default {"sponsors":"Sponsors_sponsors__BszB3","sponsors-logo":"Sponsors_sponsors-logo__xG7Ch"};